import { render, staticRenderFns } from "./RolePermissionsForm.vue?vue&type=template&id=29977249&scoped=true&"
import script from "./RolePermissionsForm.vue?vue&type=script&lang=js&"
export * from "./RolePermissionsForm.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionsForm.vue?vue&type=style&index=0&id=29977249&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29977249",
  null
  
)

export default component.exports